$(document).ready(function(){

  var splideProductGallery = new Splide('#product-gallery', {
    arrows: true,
    drag: 'free',
    pagination: false,
    focus: 'left',
    type: "loop",
    perPage: 2,
    snap: true,
    gap: 16,
    breakpoints: {
      1549: {
        perPage: 2
      },
      1399: {
        perPage: 2
      },
      1299: {
        perPage: 1.5
      },
      1199: {
        perPage: 1
      },
      1023: {
        perPage: 2,
        drag: true
      },
      767: {
        perPage: 1.5,
        focus: 'center'
      },
      576: {
        perPage: 1,
        gap: 0,
        type: "slide",
        drag: true,
        snap: true
      }
    }
  });

  $('.product-general-info').addClass('loaded');
  $('.gallery-main').addClass('loaded');
  
  var bar = splideProductGallery.root.querySelector( '.gallery-progress-bar' );

  // Updates the bar width whenever the carousel moves:
  splideProductGallery.on( 'mounted move', function () {
    var end  = splideProductGallery.Components.Controller.getEnd() + 1;
    var rate = Math.min( ( splideProductGallery.index + 1 ) / end, 1 );
    bar.style.width = String( 100 * rate ) + '%';
  } );
  
  splideProductGallery.mount();
});